import { LanguageSwitcherProps } from '@shared/types'
import { Avatar, Button, Dropdown, MenuProps, Typography } from 'antd'

/**
 * @param currentLang - The current language of the application
 * @param languages - The list of languages to display in the dropdown
 * @param onLanguageChange - The function to call when the language is changed
 * @description This component is used to switch between different languages in the application.
 * @example
 * ```tsx
 * <LanguageSwitcher
 *   currentLang={currentLang}
 *   languages={languages}
 *   onLanguageChange={handleLanguageChange}
 * />
 * ```
 */

export const LanguageSwitcher = ({
  currentLang,
  languages,
  onLanguageChange
}: LanguageSwitcherProps) => {
  if (!languages || !onLanguageChange || !currentLang) {
    return null
  }

  const menuItems: MenuProps['items'] = languages?.map((lang) => ({
    key: lang.value,
    onClick: () => onLanguageChange(lang.value),
    icon: <Avatar size={18} src={`/flags/${lang.icon}`} />,
    label: <Typography.Text strong>{lang.label}</Typography.Text>
  }))

  return (
    <Dropdown
      menu={{
        items: menuItems,
        selectedKeys: [currentLang?.value]
      }}
      placement="bottom"
    >
      <Button
        type="text"
        icon={<Avatar size={24} src={`/flags/${currentLang.icon}`} />}
      >
        <Typography.Text strong>{currentLang?.label}</Typography.Text>
      </Button>
    </Dropdown>
  )
}
